/// <reference path="../typings/tsd.d.ts" />

import { PartialViews, Routes, AppServices, AppControllers } from './helpers/config_keys';
import { AppRoutes } from "./app_routes"
import { RequestInterceptor } from './services/request_interceptor';
import { MainCtrl } from "./main/main_ctrl"
import { DashboardCtrl } from "./main/dashboard_ctrl"
import { LoginCtrl } from "./authentication/login_ctrl"
import { UserProfileCtrl } from "./user_profile/user_profile_ctrl"
import { AuthService, IAuthService } from "./authentication/auth_service"
import { Authorize } from './authentication/authorize'
import { SettingsCtrl } from './settings/settings_ctrl';
import { SettingCtrl } from './settings/settings_ctrl';
import { LookUpService } from './settings/lookup_service';
import { UsersCtrl } from './admin/users_ctrl';
import { RolesCtrl } from './admin/roles_ctrl';
import { UserService } from './admin/user_service';
import { RoleService } from './admin/role_service';
import { StatsService } from './main/stats_service';
import { MemberCtrl } from './members/members_ctrl';
import { MemberAccountCtrl } from './members/member_account_ctrl';
import { MemberService } from './members/member_service';
import { TransactionCtrl } from './transactions/transactions_ctrl';
import { TransactionFormCtrl } from './transactions/transaction_form_ctrl';
import { TransactionService } from './transactions/transaction_service';
import { InvestmentsCtrl } from './investments/investments_ctrl';
import { InvestmentCtrl, MemberMonthlyInterestCtrl } from './investments/investment_ctrl';
import { InvestmentService } from './investments/investment_service';
import { DataUploadCtrl } from './settings/data_upload_ctrl';
import { ReportsConfig } from './reports/report_config';
import { ReportsCtrl } from './reports/reports_ctrl';
import { ReportViewerCtrl } from './reports/report_viewer_ctrl';
import { ReportService } from "./reports/report_service";
import { PreviewerCtrl } from "./reports/previewerctrl";

let app = angular.module('app', ['ui.router', 'ui.bootstrap', 'ui.select2', 'ngAnimate', 'ngSanitize', 'alcoder.components', 'alcoder.services'])
	//Register Directives
	.directive('authorize', Authorize.Factory())

	//Register Controllers
	.controller(AppControllers.LoginCtrl, LoginCtrl)
	.controller(AppControllers.UserProfileCtrl, UserProfileCtrl)
	.controller(AppControllers.MainCtrl, MainCtrl)
	.controller(AppControllers.DashboardCtrl, DashboardCtrl)
	.controller(AppControllers.SettingsCtrl, SettingsCtrl)
	.controller(AppControllers.SettingCtrl, SettingCtrl)
	.controller(AppControllers.UsersCtrl, UsersCtrl)
	.controller(AppControllers.RolesCtrl, RolesCtrl)
	.controller(AppControllers.MemberCtrl, MemberCtrl)
	.controller(AppControllers.TransactionCtrl, TransactionCtrl)
	.controller(AppControllers.TransactionFormCtrl, TransactionFormCtrl)
	.controller(AppControllers.MemberAccountCtrl, MemberAccountCtrl)
	.controller(AppControllers.InvestmentsCtrl, InvestmentsCtrl)
	.controller(AppControllers.InvestmentCtrl, InvestmentCtrl)
	.controller(AppControllers.DataUploadCtrl, DataUploadCtrl)
	.controller(AppControllers.ReportsCtrl, ReportsCtrl)
	.controller(AppControllers.ReportViewerCtrl, ReportViewerCtrl)
	.controller(AppControllers.MemberMonthlyInterestCtrl, MemberMonthlyInterestCtrl)
	.controller(AppControllers.PreviewerCtrl, PreviewerCtrl)

	//Register Services
	.service(AppServices.RequestInterceptor, RequestInterceptor)
	.service(AppServices.AuthService, AuthService)
	.service(AppServices.UserService, UserService)
	.service(AppServices.RoleService, RoleService)
	.service(AppServices.MemberService, MemberService)
	.service(AppServices.LookUpService, LookUpService)
	.service(AppServices.TransactionService, TransactionService)
	.service(AppServices.InvestmentService, InvestmentService)
	.service(AppServices.StatsService, StatsService)
	.service(AppServices.ReportsConfig, ReportsConfig)
	.service(AppServices.ReportService, ReportService)


app.config(AppRoutes);

app.value("BASEAPI", "api");

app.config((uibDatepickerPopupConfig: angular.ui.bootstrap.IDatepickerPopupConfig, uibDatepickerConfig: angular.ui.bootstrap.IDatepickerConfig) => {
	uibDatepickerConfig.showWeeks = false;
	uibDatepickerPopupConfig.datepickerPopup = "dd-MMMM-yyyy";
	uibDatepickerPopupConfig.clearText = "Clear";
	uibDatepickerPopupConfig.closeText = "Close";
});


app.run(($rootScope: angular.IRootScopeService, $state: angular.ui.IStateService, AuthService: IAuthService) => {
	$rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
		if (toState.authorize) {
			if (!AuthService.isLogin()) {
				//User is not Login
				$state.transitionTo(Routes.Login)
				event.preventDefault();
			} else if (toState.permission) {
				if (!AuthService.isAuthorize(toState.permission)) {
					//User doesn't have permission
					$state.transitionTo(Routes.UnAuthorized)
					event.preventDefault();
				}
			}
		}
	})
});

app.run(($templateCache: angular.ITemplateCacheService) => {
	$templateCache.put(PartialViews.DocumentViewer, require("./reports/previewer.html"))
	$templateCache.put(PartialViews.UserForm, require("./admin/user_form.html"))
	$templateCache.put(PartialViews.RoleForm, require("./admin/role_form.html"))
	$templateCache.put(PartialViews.MemberForm, require("./members/member_form.html"))
	$templateCache.put(PartialViews.TransactionForm, require("./transactions/transaction_form.html"))
	$templateCache.put(PartialViews.InvestmentForm, require("./investments/investment_form.html"))
	$templateCache.put(PartialViews.MemberMonthlyInterest, require("./investments/member_monthly_interest.html"))

	ReportsConfig.reportsList().forEach((report) => {
		if (report.lookUps) {
			$templateCache.put(`${report.name}_report`, ReportsConfig.makeFilterTemplate(report))
		}
	})
})


app.factory("ProcessStream", ["$rootScope", ($rootScope: angular.IRootScopeService) => {
    return {
        on: (eventName: string, callback: any) => {
            let jQ: any = $;
            let connectionString = "";
            if (window.location.hostname === "localhost") connectionString = "http://localhost:7800";
            let connection = jQ.hubConnection(connectionString);
            let processHubProxy = connection.createHubProxy("processHub");

            processHubProxy.on(eventName, function (res: any) {
                let args = arguments;
                $rootScope.$apply(() => {
                    callback.apply(processHubProxy, args);
                });
            });
            let isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
            connection.start({ jsonp: isChrome }).done(() => { });
        }
    }
}])

//Hide Preloader
$("#preloader-body").hide();

export { app }


// WEBPACK FOOTER //
// ./app/app.ts